import * as React from 'react';

import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '../lib/utils';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      'vai-relative vai-flex vai-w-full vai-touch-none vai-select-none vai-items-center',
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track className="vai-relative vai-h-2 vai-w-full vai-grow vai-overflow-hidden vai-rounded-full vai-bg-secondary">
      <SliderPrimitive.Range className="vai-absolute vai-h-full vai-bg-primary" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="vai-block vai-h-5 vai-w-5 vai-rounded-full vai-border-2 vai-border-primary vai-bg-background vai-ring-offset-background vai-transition-colors focus-visible:vai-outline-none focus-visible:vai-ring-2 focus-visible:vai-ring-ring focus-visible:vai-ring-offset-2 disabled:vai-pointer-events-none disabled:vai-opacity-50" />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
